// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__22ZQL","checkboxCol":"Table_checkboxCol__FEZjS","emailCol":"Table_emailCol__1HTWj","actionCol":"Table_actionCol__3obPb"};